module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Friends and family, you supported me during my toughest challenges and for that I am truly grateful. Like so many others, I needed the encouragement to keep going, so thank you for not allowing me to settle. Thank you for continually putting me in situations in which I could grow and see just how amazing I truly am. Lastly, thank you for being the inspiration I needed to find my voice and become the person I knew I could be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mentors, coaches, and advisors, words cannot express what it has meant to receive your guidance and support over the years. In many ways, you took a chance on me by believing in my capabilities long before I did. You led me to create my own path and held my hand every step of the way. Thank you for knowing just what I needed to keep pushing forward. I will always acknowledge and be grateful for your support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lastly, special thanks to Danielle C. Miller, Patricia A. Sullivan, and Dr. Lashun Aron for your feedback and contributions.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 78
// module chunks = 0